/**
 * Course type identifier for the Self-Paced course type.
 * Use this constant instead of comparing against the human-readable title
 * so logic does not depend on display text and can switch to type.key when available.
 */
export const SELF_PACED_COURSE_KEY = 'Self-Paced';
